import { CODE_TYPE, DEVICE_TYPE, PAYMENT_TYPES, RESTRICTION_TYPE } from "../../../Common/constants";
import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/fr";
import { formatEpochTimeSeconds, isEpochTimeBeforeNow } from "./utils";

export default {
  locale: "fr",
  name: "Types de paiement",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "type",
        displayName: "Type de paiement",
      },
      {
        fieldName: "title",
        displayName: "Titre",
      },
      {
        fieldName: "minRelease",
        displayName: "Libération min. (h)",
      },
      {
        fieldName: "maxRelease",
        displayName: "Libération max. (h)",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "type",
      },
      {
        fieldName: "merchantId",
        displayName: "ID du commerçant",
      },
      {
        fieldName: "merchantPassword",
        displayName: "Mot de passe du commerçant",
      },
      {
        fieldName: "merchantAccount",
        displayName: "Compte du commerçant",
      },
      {
        fieldName: "publicApiKey",
        displayName: "Clé client",
      },
      {
        fieldName: "prefix",
        displayName: "Préfixe de production",
      },
      {
        fieldName: "installmentsIsActive",
        displayName: "Paiement échelonné activé ?",
      },
      {
        fieldName: "installmentsValues",
        displayName: "Valeurs d'échelonnement",
      },
      {
        fieldName: "secret",
        displayName: ({ formValues }) =>
          formValues.type === PAYMENT_TYPES.CRIPTAN ? "Secret" : "Clé",
      },
      {
        fieldName: "notificationSecret",
        displayName: "Secret de notification",
        helpText:
          "Cette clé est utilisée uniquement pour la vérification des notifications de paiement.",
      },
      {
        fieldName: "hmacKey",
        helpText: "Obligatoire. Utilisé pour la vérification des notifications de paiement Adyen.",
      },
      {
        fieldName: "signaturePassword",
        helpText:
          "Obligatoire. Utilisé pour la vérification des notifications de paiement Paycomet.",
      },
      {
        fieldName: "rebatePassword",
        displayName: "Mot de passe de remboursement",
      },
      {
        fieldName: "pnpClient",
        displayName: "Client",
      },
      {
        fieldName: "pnpGateway",
        displayName: "Lettre de paiement",
      },
      {
        fieldName: "key",
        displayName: "Clé",
      },
      {
        fieldName: "clave256",
        displayName: "Clé de chiffrement",
      },
      {
        fieldName: "allowTokenize",
        displayName: "Accepter la tokenisation",
      },
      {
        fieldName: "Ds_Merchant_MerchantCode",
        displayName: "Code commerçant",
      },
      {
        fieldName: "Ds_Merchant_Terminal",
        displayName: "Terminal commerçant",
      },
      {
        fieldName: "Ds_Merchant_Currency",
        displayName: "Devise commerçant",
      },
      {
        fieldName: "Ds_Merchant_MerchantURL",
      },
      {
        fieldName: "url",
        displayName: "URL",
        helpText:
          'URL de test "https://sis-t.redsys.es:25443/sis/realizarPago" / production https://sis.redsys.es/sis/realizarPago',
      },
      {
        fieldName: "clientId",
        displayName: "Client",
      },
      {
        fieldName: "description",
        displayName: "Description",
      },
      {
        fieldName: "descriptionWithDeposit",
        displayName: "Description pour acompte",
      },
      {
        fieldName: "descriptionWithoutDeposit",
        displayName: "Description sans acompte",
      },
      {
        fieldName: "roomLockHours",
        displayName: "Blocage de disponibilité",
        helpText:
          "Nombre d'heures pendant lesquelles la réservation est sauvegardée pour le client",
      },
      {
        fieldName: "automaticCancellation",
        displayName: "Annuler automatiquement toutes les réservations dont le blocage a expiré",
      },
      {
        fieldName: "minDuration",
        displayName: "Libération min. (h)",
        helpText:
          "Si la libération est inférieure, l'utilisateur ne peut pas sélectionner ce type de paiement",
      },
      {
        fieldName: "maxDuration",
        displayName: "Libération max. (h)",
        helpText:
          "Si la libération est supérieure, l'utilisateur ne peut pas sélectionner ce type de paiement",
      },
      {
        fieldName: "codesSection",
        displayName: "Code",
        helpText:
          "Le mode de paiement ne sera activé que lorsque ce code aura été saisi dans le moteur de réservation.",
      },
      {
        fieldName: "codeType",
        displayName: "",
        optionDisplay: {
          [CODE_TYPE.NO_CODE]: {
            label: "Sans code",
          },
          [CODE_TYPE.UNIVERSAL_CODE]: {
            label: "Code universel",
          },
        },
      },
      {
        fieldName: RESTRICTION_TYPE.CODE,
        displayName: "",
      },
      {
        fieldName: RESTRICTION_TYPE.DEVICE_TYPE,
        displayName: "Type d'appareil",
        widget: "multicheckbox",
        defaultValue: [],
        selectables: true,
        options: [
          {
            ticker: DEVICE_TYPE.DESKTOP,
            name: "Ordinateur",
          },
          {
            ticker: DEVICE_TYPE.TABLET,
            name: "Tablette",
          },
          {
            ticker: DEVICE_TYPE.MOBILE,
            name: "Mobile",
          },
        ],
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "paymentMethods",
        displayName: "Méthodes de paiement",
        helpText:
          "Si le champ est vide, toutes les méthodes de paiement disponibles seront appliquées",
      },
      {
        fieldName: "gatewayMerchantId",
        displayName: "Gateway Merchant Id",
      },
      {
        fieldName: "googlePayMerchantId",
        // The field is shared with SIPAY, where this warning does not apply and the name it
        // already had must stay, so only PNP_SDK gets the wording.
        helpText: ({ formValues }) =>
          formValues.type === PAYMENT_TYPES.PNP_SDK
            ? "Obligatoire en production pour Google Pay express. S'il est omis, Google rejette la feuille de paiement et l'échec n'est pas visible dans le moteur de réservation."
            : undefined,
        helpTextClassName: "text-red-500",
      },
      {
        fieldName: "accountType",
        displayName: "Compte",
        helpText: "Seul un nouveau compte ou un compte lié à Septeo/Tesipro peut être associé",
        helpTextClassName: "text-red-500",
        options: [
          {
            value: "-",
            label: "-",
          },
          {
            value: "NEW",
            label: "Créer un nouveau compte",
          },
          {
            value: "EXISTING",
            label: "Lier un compte Septeo/Tesipro",
          },
        ],
      },
      {
        fieldName: "stripeAccountButton",
        displayBtn: "Créer un compte lié",
      },
      {
        fieldName: "accountLink",
        displayName: "Lien d'intégration de compte",
        transform: ({ field, formValues }) => {
          const isExpired = isEpochTimeBeforeNow(formValues.accountLinkExpiresAt);
          const { date, time } = formatEpochTimeSeconds(formValues.accountLinkExpiresAt);

          return {
            ...field,
            helpText: isExpired
              ? "Le lien a expiré, vous devez générer un nouveau lien."
              : `Le lien expire à : ${time} h le ${date}`,
            helpTextClassName: "text-red-500",
          };
        },
      },
      {
        fieldName: "stripeAccountLinkButton",
        displayBtn: "Régénérer le lien",
      },
      {
        fieldName: "componentType",
        displayName: "Component Type",
        widget: "autoComplete",
        closeMenuOnSelect: false,
        className: "w-64",
        visible: ({ formValues }) =>
          formValues.type === PAYMENT_TYPES.STRIPE ||
          formValues.type === PAYMENT_TYPES.SEPTEO_PAYMENTS ||
          formValues.type === PAYMENT_TYPES.SIPAY ||
          formValues.type === PAYMENT_TYPES.PNP_SDK,
        transform: ({ entity, field }) => {
          switch (entity.type) {
            case PAYMENT_TYPES.SEPTEO_PAYMENTS:
              return {
                ...field,
                defaultValue: entity.properties.componentType || "dropIn",
                options: [
                  {
                    label: "Paiement par carte de crédit",
                    value: "dropIn",
                  },
                  {
                    label: "Paiement express",
                    value: "express",
                  },
                ],
              };

            // Stripe's own wording ("Payment Element") means nothing for PNP_SDK, whose two
            // modalities are the in-page Checkout SDK and the wallet express flow.
            case PAYMENT_TYPES.PNP_SDK:
              return {
                ...field,
                defaultValue: entity.properties.componentType || "standard",
                options: [
                  {
                    label: "Paiement standard",
                    value: "standard",
                  },
                  {
                    label: "Paiement express",
                    value: "express",
                  },
                ],
              };

            case PAYMENT_TYPES.STRIPE:
            case PAYMENT_TYPES.SIPAY:
            default:
              return {
                ...field,
                defaultValue: entity.properties.componentType || "standard",
                options: [
                  {
                    label: "Payment Element",
                    value: "standard",
                  },
                  {
                    label: "Express Check-out Element",
                    value: "express",
                  },
                ],
              };
          }
        },
      },
    ],
  },
};
